import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, vModelText as _vModelText, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelCheckbox as _vModelCheckbox } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-header d-flex justify-content-between align-items-center" }
const _hoisted_3 = { class: "card-body" }
const _hoisted_4 = { class: "mb-3" }
const _hoisted_5 = ["disabled"]
const _hoisted_6 = {
  key: 0,
  class: "mt-2"
}
const _hoisted_7 = { class: "mt-4" }
const _hoisted_8 = ["disabled"]
const _hoisted_9 = {
  key: 0,
  class: "spinner-border spinner-border-sm me-2",
  role: "status",
  "aria-hidden": "true"
}
const _hoisted_10 = ["disabled"]
const _hoisted_11 = {
  key: 0,
  class: "card mt-4 mb-20"
}
const _hoisted_12 = { class: "card-body" }
const _hoisted_13 = { class: "table-responsive" }
const _hoisted_14 = { class: "table align-middle" }
const _hoisted_15 = { class: "text-center" }
const _hoisted_16 = ["onUpdate:modelValue"]
const _hoisted_17 = ["onUpdate:modelValue"]
const _hoisted_18 = ["onUpdate:modelValue", "onChange", "onInput"]
const _hoisted_19 = {
  key: 0,
  class: "text-danger small"
}
const _hoisted_20 = {
  key: 1,
  class: "text-warning small"
}
const _hoisted_21 = {
  key: 2,
  class: "text-warning small"
}
const _hoisted_22 = ["onUpdate:modelValue"]
const _hoisted_23 = ["onUpdate:modelValue", "onChange"]
const _hoisted_24 = ["onUpdate:modelValue"]
const _hoisted_25 = ["onUpdate:modelValue"]
const _hoisted_26 = ["onUpdate:modelValue"]
const _hoisted_27 = {
  key: 0,
  class: "d-flex gap-2 mt-1"
}
const _hoisted_28 = ["onUpdate:modelValue"]
const _hoisted_29 = ["onUpdate:modelValue"]
const _hoisted_30 = { class: "text-center" }
const _hoisted_31 = { class: "form-check form-switch d-inline-block" }
const _hoisted_32 = ["onUpdate:modelValue"]
const _hoisted_33 = ["onClick"]
const _hoisted_34 = { class: "row mt-3" }
const _hoisted_35 = { class: "col-12" }
const _hoisted_36 = ["disabled"]
const _hoisted_37 = {
  key: 0,
  class: "spinner-border spinner-border-sm me-2"
}
const _hoisted_38 = { class: "col-12 mt-2" }
const _hoisted_39 = {
  class: "progress",
  style: {"height":"20px"}
}
const _hoisted_40 = ["aria-valuenow"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_select = _resolveComponent("v-select")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _cache[8] || (_cache[8] = _createElementVNode("h5", { class: "mb-0" }, "Nouveau Colis", -1)),
        _createElementVNode("button", {
          type: "button",
          class: "btn btn-primary",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.importModel && _ctx.importModel(...args)))
        }, _cache[7] || (_cache[7] = [
          _createElementVNode("i", { class: "flaticon-cloud-computing me-2" }, null, -1),
          _createElementVNode("span", null, "Télecharger Un modèle", -1)
        ]))
      ]),
      _createElementVNode("div", _hoisted_3, [
        _cache[13] || (_cache[13] = _createElementVNode("hr", null, null, -1)),
        _createElementVNode("div", _hoisted_4, [
          (_openBlock(), _createElementBlock("input", {
            type: "file",
            class: "form-control",
            placeholder: "Choisissez un fichier ou déposez-le ici...",
            accept: ".xlsx,.xls",
            key: _ctx.fileInputKey,
            onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onFileChange && _ctx.onFileChange(...args))),
            disabled: _ctx.load
          }, null, 40, _hoisted_5)),
          (_ctx.import_file)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _cache[9] || (_cache[9] = _createTextVNode(" Le fichier Importé: ", -1)),
                _createElementVNode("strong", null, _toDisplayString(_ctx.import_file.name), 1)
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-success",
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.ImportColis && _ctx.ImportColis(...args))),
            disabled: _ctx.load
          }, [
            (_ctx.load)
              ? (_openBlock(), _createElementBlock("span", _hoisted_9))
              : _createCommentVNode("", true),
            _cache[10] || (_cache[10] = _createElementVNode("i", { class: "flaticon-cloud-computing me-2" }, null, -1)),
            _cache[11] || (_cache[11] = _createTextVNode(" Enregistrer les colis ", -1))
          ], 8, _hoisted_8),
          (_ctx.import_file)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                type: "button",
                class: "btn btn-danger ms-3",
                onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.RemoveFile && _ctx.RemoveFile(...args))),
                disabled: _ctx.load
              }, _cache[12] || (_cache[12] = [
                _createElementVNode("i", { class: "flaticon-delete me-2" }, null, -1),
                _createTextVNode(" Supprimer le fichier importé ", -1)
              ]), 8, _hoisted_10))
            : _createCommentVNode("", true)
        ]),
        _cache[14] || (_cache[14] = _createElementVNode("hr", null, null, -1))
      ])
    ]),
    (_ctx.ListColis.length != 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
          _cache[30] || (_cache[30] = _createElementVNode("div", { class: "card-header" }, [
            _createElementVNode("h5", { class: "mb-0" }, "Nouveau Colis")
          ], -1)),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("form", null, [
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("table", _hoisted_14, [
                  _createElementVNode("thead", null, [
                    _createElementVNode("tr", null, [
                      _cache[17] || (_cache[17] = _createElementVNode("th", null, "Code suivi", -1)),
                      _cache[18] || (_cache[18] = _createElementVNode("th", null, "Destinataire", -1)),
                      _cache[19] || (_cache[19] = _createElementVNode("th", null, "Téléphone", -1)),
                      _cache[20] || (_cache[20] = _createElementVNode("th", null, "Adresse", -1)),
                      _cache[21] || (_cache[21] = _createElementVNode("th", null, "Prix", -1)),
                      _cache[22] || (_cache[22] = _createElementVNode("th", null, "Ville", -1)),
                      _cache[23] || (_cache[23] = _createElementVNode("th", null, "Commentaire", -1)),
                      _cache[24] || (_cache[24] = _createElementVNode("th", null, "Produit", -1)),
                      _cache[25] || (_cache[25] = _createElementVNode("th", null, "Type Colis", -1)),
                      _createElementVNode("th", _hoisted_15, [
                        _cache[16] || (_cache[16] = _createElementVNode("small", { class: "d-block text-muted mb-1" }, "Ouvrir", -1)),
                        _withDirectives(_createElementVNode("select", {
                          class: "form-select form-select-sm shadow-none",
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.open) = $event)),
                          onChange: _cache[5] || (_cache[5] = ($event: any) => (_ctx.AllOpen()))
                        }, _cache[15] || (_cache[15] = [
                          _createElementVNode("option", { value: 1 }, "Oui", -1),
                          _createElementVNode("option", { value: 0 }, "Non", -1)
                        ]), 544), [
                          [_vModelSelect, _ctx.open]
                        ])
                      ]),
                      _cache[26] || (_cache[26] = _createElementVNode("th", null, null, -1))
                    ])
                  ]),
                  _createElementVNode("tbody", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.ListColis, (coli, index) => {
                      return (_openBlock(), _createElementBlock("tr", { key: index }, [
                        _createElementVNode("td", null, [
                          _withDirectives(_createElementVNode("input", {
                            type: "text",
                            class: "form-control",
                            "onUpdate:modelValue": ($event: any) => ((coli.code_suivi) = $event),
                            style: _normalizeStyle(
                      coli.error == 'code exist' ? 'border-color: red;' : ''
                    )
                          }, null, 12, _hoisted_16), [
                            [_vModelText, coli.code_suivi]
                          ])
                        ]),
                        _createElementVNode("td", null, [
                          _withDirectives(_createElementVNode("input", {
                            type: "text",
                            class: "form-control",
                            "onUpdate:modelValue": ($event: any) => ((coli.destinataire) = $event),
                            style: _normalizeStyle(
                      coli.error == 'error dest' || !coli.destinataire
                        ? 'border-color: red;'
                        : ''
                    ),
                            required: ""
                          }, null, 12, _hoisted_17), [
                            [_vModelText, coli.destinataire]
                          ])
                        ]),
                        _createElementVNode("td", null, [
                          _withDirectives(_createElementVNode("input", {
                            type: "number",
                            class: "form-control",
                            "onUpdate:modelValue": ($event: any) => ((coli.telephone) = $event),
                            style: _normalizeStyle(
                      coli.phone_error || !coli.telephone
                        ? 'border-color: red;'
                        : ''
                    ),
                            onChange: ($event: any) => {
                      _ctx.BlackList(coli);
                      _ctx.checkWhite(coli);
                    },
                            onInput: ($event: any) => (_ctx.checkPhone(coli)),
                            required: "",
                            minlength: "10",
                            maxlength: "10"
                          }, null, 44, _hoisted_18), [
                            [_vModelText, coli.telephone]
                          ]),
                          (coli.phone_error)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_19, " Erreur numéro téléphone "))
                            : _createCommentVNode("", true),
                          (coli.bl)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_20, " * " + _toDisplayString(coli.bl), 1))
                            : _createCommentVNode("", true),
                          (coli.wl)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_21, " * " + _toDisplayString(coli.wl), 1))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("td", null, [
                          _withDirectives(_createElementVNode("input", {
                            type: "text",
                            class: "form-control",
                            "onUpdate:modelValue": ($event: any) => ((coli.adresse) = $event),
                            style: _normalizeStyle(
                      coli.error == 'error adresse' || !coli.adresse
                        ? 'border-color: red;'
                        : ''
                    ),
                            required: ""
                          }, null, 12, _hoisted_22), [
                            [_vModelText, coli.adresse]
                          ])
                        ]),
                        _createElementVNode("td", null, [
                          _withDirectives(_createElementVNode("input", {
                            type: "number",
                            class: "form-control",
                            "onUpdate:modelValue": ($event: any) => ((coli.prix) = $event),
                            min: "0",
                            style: _normalizeStyle(coli.error_price ? 'border-color: red;' : ''),
                            onChange: ($event: any) => (_ctx.GetPrice(coli, index)),
                            required: ""
                          }, null, 44, _hoisted_23), [
                            [_vModelText, coli.prix]
                          ])
                        ]),
                        _createElementVNode("td", null, [
                          _createVNode(_component_v_select, {
                            class: "custom-select-height",
                            id: 'city' + index,
                            style: _normalizeStyle([
                      coli.error_city ? { border: '1px solid red' } : '',
                    ]),
                            modelValue: coli.city,
                            "onUpdate:modelValue": ($event: any) => ((coli.city) = $event),
                            options: _ctx.CitiesList,
                            label: "ville",
                            onInput: ($event: any) => (_ctx.GetId(coli, index))
                          }, null, 8, ["id", "style", "modelValue", "onUpdate:modelValue", "options", "onInput"])
                        ]),
                        _createElementVNode("td", null, [
                          _withDirectives(_createElementVNode("input", {
                            type: "text",
                            class: "form-control",
                            "onUpdate:modelValue": ($event: any) => ((coli.commentaire) = $event)
                          }, null, 8, _hoisted_24), [
                            [_vModelText, coli.commentaire]
                          ])
                        ]),
                        _createElementVNode("td", null, [
                          _withDirectives(_createElementVNode("input", {
                            type: "text",
                            class: "form-control",
                            "onUpdate:modelValue": ($event: any) => ((coli.produit) = $event)
                          }, null, 8, _hoisted_25), [
                            [_vModelText, coli.produit]
                          ])
                        ]),
                        _createElementVNode("td", null, [
                          _withDirectives(_createElementVNode("select", {
                            class: "form-control form-select",
                            "onUpdate:modelValue": ($event: any) => ((coli.replace) = $event)
                          }, _cache[27] || (_cache[27] = [
                            _createElementVNode("option", { value: 0 }, "Simple", -1),
                            _createElementVNode("option", { value: 1 }, "Change", -1)
                          ]), 8, _hoisted_26), [
                            [_vModelSelect, coli.replace]
                          ]),
                          (coli.replace == 2)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                                _withDirectives(_createElementVNode("input", {
                                  type: "number",
                                  class: "form-control",
                                  placeholder: "Nombre envoyé",
                                  "onUpdate:modelValue": ($event: any) => ((coli.nbr_sent) = $event)
                                }, null, 8, _hoisted_28), [
                                  [_vModelText, coli.nbr_sent]
                                ]),
                                _withDirectives(_createElementVNode("input", {
                                  type: "number",
                                  class: "form-control",
                                  placeholder: "Nombre à retourné",
                                  "onUpdate:modelValue": ($event: any) => ((coli.nbr_rtrn) = $event)
                                }, null, 8, _hoisted_29), [
                                  [_vModelText, coli.nbr_rtrn]
                                ])
                              ]))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("td", _hoisted_30, [
                          _createElementVNode("div", _hoisted_31, [
                            _withDirectives(_createElementVNode("input", {
                              class: "form-check-input",
                              type: "checkbox",
                              "onUpdate:modelValue": ($event: any) => ((coli.open) = $event),
                              "true-value": 1,
                              "false-value": 0
                            }, null, 8, _hoisted_32), [
                              [_vModelCheckbox, coli.open]
                            ])
                          ])
                        ]),
                        _createElementVNode("td", null, [
                          _createElementVNode("button", {
                            type: "button",
                            class: "btn btn-danger btn-sm",
                            title: "Supprimer",
                            onClick: ($event: any) => (_ctx.RemoveRow(coli))
                          }, _cache[28] || (_cache[28] = [
                            _createElementVNode("i", { class: "flaticon-delete" }, null, -1)
                          ]), 8, _hoisted_33)
                        ])
                      ]))
                    }), 128))
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_34, [
                _createElementVNode("div", _hoisted_35, [
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn btn-primary",
                    onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.SaveColis && _ctx.SaveColis(...args))),
                    disabled: _ctx.load_add
                  }, [
                    (_ctx.load_add)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_37))
                      : _createCommentVNode("", true),
                    _cache[29] || (_cache[29] = _createTextVNode(" Enregistrer les colis ", -1))
                  ], 8, _hoisted_36)
                ]),
                _createElementVNode("div", _hoisted_38, [
                  _createElementVNode("div", _hoisted_39, [
                    _createElementVNode("div", {
                      class: "progress-bar",
                      role: "progressbar",
                      style: _normalizeStyle({ width: _ctx.progress + '%' }),
                      "aria-valuenow": _ctx.progress,
                      "aria-valuemin": "0",
                      "aria-valuemax": "100"
                    }, _toDisplayString(_ctx.progress) + "% ", 13, _hoisted_40)
                  ])
                ])
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}